import { primitives } from "@adasupport/byron";
import styled from "styled-components";

import { colorPrimitives, colorTokens, v } from "constants/css";

const DoubleDatePicker = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: ${v.gUnitTriple};
`;

export const Root = DoubleDatePicker;

export const MonthName = styled.div`
  position: relative;
  padding-bottom: ${v.gUnit};
  font-size: ${v.smallFontSize};
  line-height: ${v.largeLineHeight};
  font-weight: ${v.heavyFontWeight};
  color: ${colorTokens.textHeadings};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PrevButton = styled.span`
  position: absolute;
  left: 0;
`;

export const NextButton = styled.span`
  position: absolute;
  right: 0;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  row-gap: 2px;
  height: max-content;
`;

export const DayLabel = styled.div`
  color: ${colorTokens.textMuted};
  font-size: ${v.xxSmallFontSize};
  line-height: ${v.smallLineHeight};
  text-align: center;
`;

export const DateButton = styled.button<{
  isDisabled: boolean;
  isInRange: boolean;
  isStartDate: boolean;
  isEndDate: boolean;
}>`
  position: relative;
  background: none;
  border: none;
  padding: 2px;
  display: grid;
  place-items: center;
  color: ${(p) =>
    p.isDisabled ? colorTokens.actionDisabled : colorTokens.textMain};
  height: ${v.inputHeight};

  ${(p) =>
    !p.isDisabled &&
    `
    cursor: pointer;

    &:hover{
      background: ${colorTokens.actionHover};
      border-radius: ${v.smallerBorderRadius};
    }
  `}

  ${(p) =>
    p.isInRange &&
    `
    background: ${colorPrimitives.teal100};
  `}

  ${(p) =>
    (p.isStartDate || p.isEndDate) &&
    `
    color: ${colorTokens.textInverted};
    background: ${colorPrimitives.teal500};
    border-radius: 0%;
  `}

  ${(p) =>
    p.isStartDate &&
    `
    border-top-left-radius:${v.mainBorderRadius};
    border-bottom-left-radius:${v.mainBorderRadius};
  `}

  ${(p) =>
    p.isEndDate &&
    `
    border-top-right-radius:${v.mainBorderRadius};
    border-bottom-right-radius:${v.mainBorderRadius};
  `}
`;

export const DateButtonText = styled.span<{ isToday: boolean }>`
  display: grid;
  place-items: center;
  padding: 0 ${primitives.spacing.space2};
  font-family: inherit;
  font-size: ${v.xSmallFontSize};
  line-height: ${v.smallLineHeight};
  ${(p) =>
    p.isToday &&
    `
     color: ${colorTokens.textInverted};
     font-weight: ${v.heavyFontWeight};
     border-radius: 100%;
     background: ${colorPrimitives.black};
     height: 100%;
     width: 100%;
   `}
`;
